export default __webpack_public_path__ + "static/media/express.377897ec.jpg";